let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3aiVo")).then(() => parcelRequire('adzUP'));